module.exports = __webpack_public_path__ + "30800ae438fc7dd35534b7f3c534593a.jpg";